import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { FollowUpQueue } from './pages/FollowUpQueue';
import { RealtimeLeads } from './pages/RealtimeLeads';
import { Campaigns } from './pages/Campaigns';
import { useScreenInit } from './useScreenInit';
import { RoleProvider } from './contexts/RoleContext';
export function App() {
  useScreenInit();
  return <RoleProvider data-id="element-0" data-mp="2rknnmimlzktz">
      <Router data-id="element-1" data-mp="2rk46h44s90h0">
        <Routes data-id="element-2" data-mp="2rlp08rj9wfdt">
          <Route path="/" element={<FollowUpQueue data-id="element-4" data-mp="2rikmp3jx47ah" />} data-id="element-3" data-mp="2rl6un4aq0ot8" />
          <Route path="/realtime" element={<RealtimeLeads data-id="element-6" data-mp="2mndq0fp2g2v2" />} data-id="element-5" data-mp="2mmcc83go129n" />
          <Route path="/campaigns" element={<Campaigns data-id="element-8" data-mp="31b8lu4ydencd" />} data-id="element-7" data-mp="2mjzlp1wudjkz" />
        </Routes>
      </Router>
    </RoleProvider>;
}